import React from 'react';
import AnimatedSection from './AnimatedSection';
import StaggeredList from './StaggeredList';
import { DollarSign, AlertTriangle, Clock, Activity, Shield, Users } from 'lucide-react';

const CostImpactSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fade-up">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold mb-4" style={{ color: '#214140' }}>
                The Hidden Cost of Cord Disorganization
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                For hospital administrators: line-related problems carry real, published costs.
              </p>
            </div>

            <StaggeredList delay={100} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white rounded-xl p-6 border-l-4 hover:shadow-lg transition-shadow" style={{ borderColor: '#273139' }}>
                <DollarSign className="h-10 w-10 mb-4" style={{ color: '#273139' }} />
                <h3 className="text-2xl font-bold mb-2" style={{ color: '#214140' }}>$34,543</h3>
                <p className="font-semibold mb-2" style={{ color: '#273139' }}>Inpatient Falls</p>
                <p className="text-gray-600 text-sm">Added hospital cost per patient who falls, vs matched patients who did not (Dykes et al., 2023)</p>
              </div>

              <div className="bg-white rounded-xl p-6 border-l-4 hover:shadow-lg transition-shadow" style={{ borderColor: '#273139' }}>
                <AlertTriangle className="h-10 w-10 mb-4" style={{ color: '#273139' }} />
                <h3 className="text-2xl font-bold mb-2" style={{ color: '#214140' }}>19 million</h3>
                <p className="font-semibold mb-2" style={{ color: '#273139' }}>IV Line Dislodgements</p>
                <p className="text-gray-600 text-sm">Projected accidental IV dislodgements per year in the US (Moureau, 2018)</p>
              </div>

              <div className="bg-white rounded-xl p-6 border-l-4 hover:shadow-lg transition-shadow" style={{ borderColor: '#273139' }}>
                <Clock className="h-10 w-10 mb-4" style={{ color: '#273139' }} />
                <h3 className="text-2xl font-bold mb-2" style={{ color: '#214140' }}>61%</h3>
                <p className="font-semibold mb-2" style={{ color: '#273139' }}>Delayed Mobility</p>
                <p className="text-gray-600 text-sm">Share of ICU early-mobility session time spent managing tubes and lines (Benjamin et al., 2022)</p>
              </div>

              <div className="bg-white rounded-xl p-6 border-l-4 hover:shadow-lg transition-shadow" style={{ borderColor: '#1F8051' }}>
                <Users className="h-10 w-10 mb-4" style={{ color: '#1F8051' }} />
                <h3 className="text-2xl font-bold mb-2" style={{ color: '#214140' }}>$61,110</h3>
                <p className="font-semibold mb-2" style={{ color: '#273139' }}>Per Nurse Turnover</p>
                <p className="text-gray-600 text-sm">Average cost per bedside RN; critical care RN turnover was 18.3% in 2024 (NSI 2025 report)</p>
              </div>
            </StaggeredList>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default CostImpactSection;
